import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, TouchableOpacity, View, ViewStyle } from 'react-native';

export const dotDiameter = 10;

interface DotProps {
  active: boolean;
  activeStyle?: StyleProp<ViewStyle>;
  index: number;
  onPress: (index: number) => void;
}

const Dot: React.FC<DotProps> = ({ active, activeStyle, index, onPress }) => {
  const [styles] = useStyles();
  return (
    <TouchableOpacity
      disabled={active}
      onPress={() => onPress(index)}
      style={styles.dotContainer}
    >
      <View
        style={[
          styles.dot,
          active ? [styles.activeDot, activeStyle ? activeStyle : null] : null,
        ]}
        testID={`navigation-dot-${index}`}
      />
    </TouchableOpacity>
  );
};

interface Props {
  activeIndex: number;
  activeStyle?: StyleProp<ViewStyle>;
  count: number;
  onChange: (index: number) => void;
}

export const NavigationDots: React.FC<Props> = ({
  activeIndex,
  activeStyle,
  count,
  onChange,
}) => {
  const [styles] = useStyles();

  const dots = [];
  for (let i = 0; i < count; i++) {
    dots.push(
      <Dot
        active={i === activeIndex}
        activeStyle={activeStyle}
        index={i}
        key={i}
        onPress={onChange}
      />,
    );
  }

  return <View style={styles.base}>{dots}</View>;
};

const useStyles = createStyles((theme) => ({
  activeDot: {
    backgroundColor: theme.colors.primary,
  },
  base: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  dot: {
    backgroundColor: theme.colors.stroke,
    borderRadius: 5,
    height: dotDiameter,
    width: dotDiameter,
  },
  dotContainer: {
    alignSelf: 'stretch',
    justifyContent: 'center',
    paddingHorizontal: 4,
  },
}));
